import { render, staticRenderFns } from "./ItemTagListPage.vue?vue&type=template&id=17580b63&"
import script from "./ItemTagListPage.vue?vue&type=script&lang=ts&"
export * from "./ItemTagListPage.vue?vue&type=script&lang=ts&"
import style0 from "./ItemTagListPage.vue?vue&type=style&index=0&id=17580b63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports